var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action, computed } from 'mobx';
import sumBy from 'lodash.sumby';
import { TempSaleTicketLine } from './TempSaleTicketLine';
import Stretch from '../Stretches/Stretch';
import { filterHoursFromDay, generateTicketNumber, randomString, round } from 'helpers/Utils';
import Storage from 'helpers/Storage';
import { TypeDiscount } from '../DiscountReasons/IDiscount';
import { PaymentMethod, TicketPayment } from '../../Models/TicketPayment';
import { TempSaleExtraLine } from './TempSaleExtraLine';
import CollaboratorStretch from '../CollaboratorStretches/CollaboratorStretch';
export class TempSaleTicket {
    constructor(store) {
        // servicio con vuelta
        this._saleVuelta = false;
        this._dataContact = {
            name: '',
            surname: '',
            telephone: '',
            email: '',
            additionalInformation: '',
        };
        this._boardingPass = false;
        this.getStretch = () => {
            return this._stretch;
        };
        this.getLines = () => {
            return this._lines;
        };
        this.setMinus = (sale) => {
            const index = this.getIndex(sale);
            if (index >= 0) {
                // comprueba si tiene máxima cantidad que puede llevar la venta de esta categoría de pasajero
                const lineSale = this._lines[index];
                if (lineSale &&
                    sale.stretchPrice.passengerCategory.minToReserve === lineSale.quantity && sale.stretchPrice.passengerCategory.required) {
                    this.store.UI.newWarning('mímino de esta categoría alcanzado');
                    return;
                }
                if (this._lines[index].quantity > 1) {
                    this._lines[index].quantity--;
                }
                else {
                    this._lines.splice(index, 1);
                }
            }
            // quito includeExtras
            const includedExtras = this._stretch.includedExtras || [];
            if (includedExtras && includedExtras.length > 0) {
                // quito el extras por pasajero que esté incluido en lines
                // busco si la categoría de pasajero está en includedExtras
                const passengerCategory_id = sale.stretchPrice.passengerCategory.id;
                const includedExtra = includedExtras.find(includeExtra => includeExtra.passengerCategory_id === passengerCategory_id);
                if (includedExtra) {
                    console.log('includedExtra: ', includedExtra);
                    // busco el primer elemento que coincide con el id del extra en includedExtraLines
                    const indexToRemove = this._includedExtraLines.findIndex(iel => iel.saleExtra.price.extra.id === includedExtra.id);
                    this._includedExtraLines.splice(indexToRemove, 1);
                    console.log('this._includedExtraLines: ', this._includedExtraLines);
                }
            }
            // console.log('setMinus - lines.length', this.lines.length)
        };
        this.setPlus = (sale) => {
            // console.log('setPlus - sale: ', sale)
            // console.log('setPlus - sales: ', this.lines)
            // comprueba si tiene máxima cantidad que puede llevar la venta de esta categoría de pasajero
            const lineSale = this._lines[this.getIndex(sale)];
            if (lineSale &&
                sale.stretchPrice.passengerCategory.maxToReserve === lineSale.quantity) {
                this.store.UI.newWarning('máximo de esta categoría alcanzado');
                return;
            }
            if (this.checkins > 0 && this._codeDiscount !== '') {
                return;
            }
            // añado includeExtras
            const includedExtras = this._stretch.includedExtras || [];
            if (includedExtras && includedExtras.length > 0) {
                // añado los extras por pasajero que esté incluido en lines
                // busco si la categoría de pasajero está en includedExtras
                const passengerCategory_id = sale.stretchPrice.passengerCategory.id;
                const includedExtra = includedExtras.find(includeExtra => includeExtra.passengerCategory_id === passengerCategory_id);
                if (includedExtra) {
                    console.log('includedExtra: ', includedExtra);
                    // agrego a lista de includedExtraLines
                    // tomo el criterio de una línea por includedExtra
                    const tempSaleIncludedExtra = new TempSaleExtraLine({
                        price: {
                            id: includedExtra.extra.id,
                            name: includedExtra.extra.name,
                            extra: includedExtra.extra,
                            price: 0,
                            tax: includedExtra.extra.tax,
                            description: includedExtra.description,
                            isIncluded: true
                        },
                        isIncluded: true,
                        quantity: 1,
                        name: includedExtra.extra.name,
                    });
                    this._includedExtraLines.push(tempSaleIncludedExtra);
                    console.log('this._includedExtraLines: ', this._includedExtraLines);
                }
            }
            const index = this.getIndex(sale);
            // console.log('setPlus - index: ', index)
            if (index >= 0) {
                const numeroNew = generateTicketNumber(randomString(6), 'stretch');
                this._lines[index].numeroQR.push(numeroNew);
                this._lines[index].quantity++;
                console.log('this._lines: ', this._lines);
                return;
            }
            this._lines.push(new TempSaleTicketLine(sale));
            // console.log('setPlus 2- lines.length: ', this.lines.length)
        };
        this.setExtraMinus = (sale) => {
            const index = this.getIndexExtra(sale);
            if (index >= 0) {
                if (this._extraLines[index].quantity > 1) {
                    this._extraLines[index].quantity--;
                }
                else {
                    this._extraLines.splice(index, 1);
                }
            }
        };
        this.setExtraPlus = (sale) => {
            if (this.checkins > 0 && this._codeDiscount !== '') {
                return;
            }
            const index = this.getIndexExtra(sale);
            if (index >= 0) {
                this._extraLines[index].quantity++;
            }
            else {
                this._extraLines.push(new TempSaleExtraLine(sale));
            }
        };
        this.handleChangeDate = () => {
            if (this._stretch.tramoHora) {
                // pongo por defecto la más aproximada
                const { horasIda: hoursIdaWithoutFiltered, horasVuelta } = this._stretch;
                // console.log('TempSaleTicket - setStretch - horasIda: ', horasIda)
                // pongo por defecto la más aproximada
                const horasIda = filterHoursFromDay(hoursIdaWithoutFiltered, this._stretch.disabledDays, this._datebook);
                if (horasIda) {
                    this._timeIda = null;
                }
                this._timeIda = this.searchHorasIdaOk(horasIda);
                // console.log('cambiado a: ', this._timeIda)
            }
        };
        this.setMinimun = (stretch) => {
            // añado cantidad mínima de pasajero si procede
            const minimunPrices = stretch.prices.filter((price) => {
                const passengerCategory = price.passengerCategory;
                return passengerCategory.required && passengerCategory.minToReserve && price.price >= 0;
            });
            if (minimunPrices.length > 0) {
                for (let i = 0; i < minimunPrices.length; i++) {
                    const price = minimunPrices[i];
                    if (!price.tax) {
                        price.tax = stretch.tax;
                    }
                    const sale = {
                        stretchPrice: price,
                        order: price.passengerCategory.order,
                        quantity: price.passengerCategory.minToReserve,
                    };
                    if (stretch instanceof CollaboratorStretch && (!sale.stretchPrice.priceNet || sale.stretchPrice.priceNet < 0)) {
                        continue;
                    }
                    this._lines.push(new TempSaleTicketLine(sale));
                }
            }
        };
        this.searchHorasIdaOk = (horasIda) => {
            // cogemos el criterio de retornar la más cercana a la hora actual
            let resultHorasIda = horasIda[0];
            const now = new Date();
            // now.setHours(13, 0, 0, 999) // todo para simular hora actual
            for (let i = 0; i < horasIda.length; i++) {
                // console.log('************************')
                // console.log('comprobando: ', horasIda[i])
                // console.log('now: ', now)
                if (horasIda[i].hours > now.getHours()) {
                    // hora es mayor que la actual, se supone que horasIda está ordenado por lo que
                    // nos da igual los minutos, sería horaIda siguiente a la hora actual válida
                    resultHorasIda = horasIda[i];
                    break;
                }
                else if (horasIda[i].hours === now.getHours() &&
                    now.getHours() >= horasIda[i].minutes) {
                    // las horas son iguales, comprobamos minutos, si son iguales o mayores sería horaIda válida
                    resultHorasIda = horasIda[i];
                    break;
                }
                // seleccionamos por si es la última que es la más cercana
                resultHorasIda = horasIda[i];
            }
            // console.log('************************')
            return resultHorasIda;
        };
        this.setKeyValueDataContact = (key, value) => {
            this._dataContact[key] = value;
        };
        // console.log('TemSaleTicket - constructor')
        this.store = store;
        this._user = this.store.users.user;
        // this.payment = [new Payment(PaymentMethod.Cash)]
        this._numero = '';
        this.init();
        /*const date = new Date();
        this.datecheck = date
        this._datebook = date
        this.datevalited = date*/
        // reaction(() => this.total, this.payment.setAmount)
    }
    // ----------------------------------------------------
    get totalPax() {
        return this._lines.reduce((prev, curr) => {
            return prev + curr.quantity;
        }, 0);
    }
    get quantityToAdd() {
        let total = 0;
        this._lines.forEach((line) => {
            total += line.quantity;
        });
        return total;
    }
    get money() {
        return this.stretch ? this.stretch.primaryMoney.alphabeticCode : '';
    }
    get dataContact() {
        return this._dataContact;
    }
    get crossBookingNumber() {
        return this._crossBookingNumber;
    }
    get boardingPass() {
        return this._boardingPass;
    }
    get saleVuelta() {
        return this._saleVuelta;
    }
    get originDestination() {
        return this._originDestination;
    }
    // venta colaborador
    get client_id() {
        return this._client_id;
    }
    get operator_id() {
        return this._operator_id;
    }
    get collaboratorName() {
        return this._collaboratorName;
    }
    get qrTicket() {
        return this._operationLine.qrTicket;
    }
    get hoponHopoff() {
        return this._stretch.hoponHopoff;
    }
    get vuelta() {
        return this._stretch.vuelta;
    }
    get taxName() {
        return this._tax.name;
        // return this._stretch.tax!.name
    }
    get taxValue() {
        return this._tax.value;
    }
    get businessUnitName() {
        return this._operationLine.businessUnit.name;
    }
    get netAmount() {
        const sum = sumBy(this.lines, (line) => line.base);
        const sumExtras = sumBy(this._extraLines, (line) => line.base);
        // console.log('sum: ', sum)
        return round(sum + sumExtras, 2);
    }
    get netAmountNet() {
        const sum = sumBy(this.lines, (line) => line.baseNet);
        const sumExtras = sumBy(this._extraLines, (line) => line.base);
        // console.log('sum: ', sum)
        return round(sum + sumExtras, 2);
    }
    get netAmountWithoutExtras() {
        const sum = sumBy(this.lines, (line) => line.base);
        // console.log('sum: ', sum)
        return round(sum, 2);
    }
    get netAmountNetWithoutExtras() {
        const sum = sumBy(this.lines, (line) => line.baseNet);
        // console.log('sum: ', sum)
        return round(sum, 2);
    }
    get base() {
        const base = this.netAmount; /* - ( this.netAmount * ( this._discount / 100 ) )*/
        // console.log('base: ', base)
        return base;
    }
    get baseNet() {
        const baseNet = this.netAmountNet; /* - ( this.netAmount * ( this._discount / 100 ) )*/
        // console.log('base: ', base)
        return baseNet;
    }
    get baseWithoutExtras() {
        const base = this
            .netAmountWithoutExtras; /* - ( this.netAmount * ( this._discount / 100 ) )*/
        // console.log('base: ', base)
        return base;
    }
    get baseNetWithoutExtras() {
        const baseNet = this
            .netAmountNetWithoutExtras; /* - ( this.netAmount * ( this._discount / 100 ) )*/
        // console.log('base: ', base)
        return baseNet;
    }
    get taxAmount() {
        // if (!this._stretch) return 0
        if (!this._tax)
            return 0;
        const totalWithDiscount = this.base + this.taxAmountWithoutDiscount - this._discount;
        return totalWithDiscount - totalWithDiscount / (this._tax.value + 1);
        // return totalWithDiscount - ((totalWithDiscount)/(this._stretch.tax.value+1))
    }
    get taxAmountWithoutExtras() {
        // if (!this._stretch) return 0
        if (!this._tax)
            return 0;
        const totalWithDiscount = this.baseWithoutExtras +
            this.taxAmountWithoutExtrasWithoutDiscount -
            this._discount;
        return totalWithDiscount - totalWithDiscount / (this._tax.value + 1);
        // return totalWithDiscount - ((totalWithDiscount)/(this._stretch.tax.value+1))
    }
    get taxAmountWithoutDiscount() {
        const sum = sumBy(this.lines, (line) => line.taxAmount);
        const sumExtras = sumBy(this._extraLines, (line) => line.taxAmount);
        return round(sum + sumExtras, 2);
    }
    get taxAmountNetWithoutDiscount() {
        const sum = sumBy(this.lines, (line) => line.taxAmountNet);
        const sumExtras = sumBy(this._extraLines, (line) => line.taxAmount);
        return round(sum + sumExtras, 2);
    }
    get taxAmountWithoutExtrasWithoutDiscount() {
        const sum = sumBy(this.lines, (line) => line.taxAmount);
        return round(sum, 2);
    }
    get total() {
        const result = this.totalWithoutDiscount;
        let descuento = this._discount;
        if (this._typeDiscount === TypeDiscount.Percentage) {
            descuento = (result * this._discount) / 100;
        }
        if (result >= descuento) {
            return result - Math.abs(descuento);
        }
        else {
            return 0;
        }
    }
    get totalNet() {
        const result = this.totalNetWithoutDiscount;
        // al neto no le vamos a quitar el descuento, lo asume el colaborador al vender
        return result;
    }
    get totalPaid() {
        return this.total + this.totalDue;
    }
    get totalWithoutDiscount() {
        const result = round(this.base + this.taxAmountWithoutDiscount, 2);
        return result;
    }
    get totalNetWithoutDiscount() {
        const result = round(this.baseNet + this.taxAmountNetWithoutDiscount, 2);
        return result;
    }
    get datebook() {
        // return this.dateCheck // porque es la misma que la de emision
        return this._datebook;
    }
    get datecheck() {
        return this._datecheck;
    }
    get dateValited() {
        return this.datevalited;
    }
    get valitedNow() {
        return this._valitedNow;
    }
    get checkins() {
        const lines = this.lines;
        return lines.reduce((previous, current) => previous + current.quantity, 0);
    }
    get discount() {
        return this._discount;
    }
    get tramoHora() {
        return this._stretch.tramoHora;
    }
    get tipoPago() {
        return this._tipoPago;
    }
    get lastHoraIda() {
        let result = null;
        if (this._lastHoraIda && this._lastHoraIda[this.stretch.id]) {
            result = this._lastHoraIda[this.stretch.id];
        }
        // console.log('get lastHoraIda - result: ', result)
        return result;
    }
    // @computed
    get timeIda() {
        return this._timeIda;
    }
    /*@computed
    get horasVuelta() {
      console.log('**************!/!*************!/', this._horasVuelta)
      return this._horasVuelta
    }*/
    get lines() {
        return this._lines;
    }
    getIndex(sale) {
        // console.log('getIndex - lines: ', this.lines)
        return this.lines.findIndex((value) => {
            // console.log('getIndex - findIndex - value', value)
            // console.log('getIndex - findIndex - sale', sale)
            return (value.sale.stretchPrice.passengerCategory.id ===
                sale.stretchPrice.passengerCategory.id);
        });
    }
    getIndexExtra(sale) {
        return this._extraLines.findIndex((value) => {
            return value.saleExtra.price.id === sale.price.id;
        });
    }
    getLineTotal(sale) {
        const index = this.getIndex(sale);
        return index >= 0 ? this.lines[index].base : 0;
    }
    getQuantity(sale) {
        const index = this.getIndex(sale);
        if (index >= 0) {
            return this.lines[index].quantity;
        }
        return 0;
    }
    getLineTotalExtras(sale) {
        const index = this.getIndexExtra(sale);
        return index >= 0 ? this._extraLines[index].base : 0;
    }
    getQuantityExtras(sale) {
        const index = this.getIndexExtra(sale);
        if (index >= 0) {
            return this._extraLines[index].quantity;
        }
        return 0;
    }
    get stretch() {
        return this._stretch;
    }
    get operationLine() {
        return this._operationLine;
    }
    get username() {
        return `${this.store.users.user.username}`;
    }
    getBusinnesUnitName() {
        return this._operationLine.businessUnit.name;
    }
    get numero() {
        return this._numero;
    }
    get tin() {
        return this._operationLine.businessUnit.tin;
    }
    get origin() {
        if (this._originDestination) {
            return this._originDestination.origin;
        }
        return this._stretch.origin;
    }
    get destination() {
        if (this._originDestination) {
            return this._originDestination.destination;
        }
        return this._stretch.destination;
    }
    get printPrice() {
        return this._printPrice;
    }
    get timeExpiration() {
        return this._stretch.timeExpiration;
    }
    get timeUse() {
        return this._stretch.timeUse;
    }
    get timeCancel() {
        return this._stretch.timeCancel;
    }
    get timeAdvance() {
        return this._stretch.timeAdvance;
    }
    get timeDelay() {
        return this._stretch.timeDelay;
    }
    get aditionalInfo() {
        return this._stretch.aditionalInfo;
    }
    get totalCash() {
        /*const total = this.totalWithoutDiscount - (this._totalCard + this._totalCredit + this._totalTransfer + this._totalOther)
        let descuento = this.totalDiscount
        if (total >= descuento) {
          this.setInputCash(total - Math.abs(descuento))
        } else {
          this.setInputCash(0)
        }*/
        return (this.totalWithoutDiscount -
            Math.abs(this.totalDiscount) -
            this.totalCard -
            this.totalCredit -
            this.totalTransfer -
            this.totalOther -
            this.totalDue);
    }
    get totalCard() {
        return this._totalCard;
    }
    get totalDue() {
        return this._totalDue;
    }
    get totalCredit() {
        return this._totalCredit;
    }
    get totalTransfer() {
        return this._totalTransfer;
    }
    get totalOther() {
        return this._totalOther;
    }
    get afiliate() {
        return this._afiliate;
    }
    get typeDiscount() {
        return this._typeDiscount;
    }
    get totalDiscount() {
        if (this._typeDiscount === TypeDiscount.Fix)
            return this._discount;
        return (this.totalWithoutDiscount * this._discount) / 100;
    }
    get discountReason() {
        return this._discountReason;
    }
    get user() {
        return this._user;
    }
    get codeDiscount() {
        return this._codeDiscount;
    }
    init() {
        this._lines = [];
        this._extraLines = [];
        this._includedExtraLines = [];
        this._discount = 0;
        this._codeDiscount = '';
        /*this._valitedNow = false // comentar para usar el último valor*/
        this.datevalited = null;
        this._datebook = new Date();
        this._tipoPago = PaymentMethod.Cash;
        this._datebook = new Date(); // inicializo al día actual
        this._totalCard = 0;
        this._totalDue = 0;
        this._totalCredit = 0;
        this._totalTransfer = 0;
        this._totalOther = 0;
        this._typeDiscount = TypeDiscount.Percentage;
        this._discount = 0;
        // si el usuario es afiliado no reseteo _afiliate
        if (!this.user.afiliate) {
            this._afiliate = null;
        }
        // tengo duda en si debo resetear originDestination
        // this._originDestination = null
        this._printPrice = true;
        this._crossBookingNumber = '';
        this._dataContact = {
            name: '',
            surname: '',
            telephone: '',
            email: '',
            additionalInformation: '',
        };
        this._boardingPass = false;
    }
    reset() {
        // console.log('antes - lines.length', this.lines.length)
        this.init();
        // console.log('despues - lines.length', this.lines.length)
    }
    pushLine(sale) {
        // console.log('pushLine - sale: ', sale)
        const index = this.getIndex(sale);
        if (index >= 0) {
            this.lines[index].quantity = ++sale.quantity;
        }
        else {
            const line = new TempSaleTicketLine(sale);
            this.lines.push(line);
        }
    }
    pullLine(line) {
        this.lines.splice(this.lines.findIndex((l) => l === line), 1);
    }
    // servicio con vuelta seleccionada
    setSaleVuelta(value) {
        this._saleVuelta = value;
    }
    toggleOriginDestination() {
        const oldDestination = this._originDestination.destination;
        this._originDestination.destination = this._originDestination.origin;
        this._originDestination.origin = oldDestination;
    }
    // venta colaborador
    setClientId(client_id) {
        this._client_id = client_id;
    }
    setCollaboratorName(collaboratorName) {
        this._collaboratorName = collaboratorName;
    }
    setOperatorId(value) {
        this._operator_id = value;
    }
    setOperatorName(value) {
        this._operatorName = value;
    }
    setDatecheck(date) {
        this._datecheck = date;
    }
    setDatebook(date) {
        if (date) {
            // No es Hop o si lo es se ha seleccionado día
            if (!this.stretch.tramoHora) {
                date.setHours(0);
                date.setMinutes(0);
            }
            date.setSeconds(0);
            date.setMilliseconds(0);
        }
        this._datebook = date;
    }
    setDatevalited(date) {
        this.datevalited = date;
    }
    setValitedNow(valitedNow) {
        this._valitedNow = valitedNow;
    }
    setPrintPrice(value) {
        this._printPrice = value;
    }
    setDiscount(discount) {
        this._discount = discount;
    }
    setCodeDiscount(code, discount) {
        if (discount !== undefined) {
            this.setDiscount(discount);
        }
        this._codeDiscount = code;
    }
    setStretch(stretch) {
        if ((stretch.vuelta && !this._stretch) ||
            (this._stretch && this._stretch.id !== stretch.id)) {
            // si seteo el servicio la primera vez o si cambio de servicio actualizo origin y destination
            this._originDestination = {
                origin: stretch.origin,
                destination: stretch.destination,
            };
        }
        this._stretch = stretch instanceof CollaboratorStretch ? new CollaboratorStretch(stretch) : new Stretch(stretch);
        if (this._stretch.tramoHora) {
            const { horasVuelta } = this._stretch;
            // console.log('TempSaleTicket - setStretch - horasIda: ', horasIda)
            // pongo por defecto la más aproximada
            // const horasIda = filterHoursFromDay(hoursIdaWithoutFiltered, this._stretch.disabledDays, this._datebook)
            // this._timeIda = this.searchHorasIdaOk(horasIda)
            this.handleChangeDate();
            if (horasVuelta) {
                this.horasVuelta = horasVuelta;
            }
            // console.log('TempSaleTicket - setStretch - horasVuelta: ', this.stretch)
            // console.log('TempSaleTicket - setStretch - horasVuelta: ', horasVuelta)
        }
        else {
            this._timeIda = null;
        }
        this.setTax(this._stretch.tax);
        this._printPrice = this._stretch.printPrice;
        // elimino datos anteriores
        this._operatorName = null;
        this._operator_id = null;
        this._collaboratorName = null;
        this._client_id = null;
    }
    setTax(tax) {
        this._tax = tax;
    }
    setOperationLine(operationLine) {
        this._operationLine = operationLine;
    }
    setPersistenceTimeIda(timeIda) {
        let persitenceTimeIda = JSON.parse(Storage.get('lastTimeIda'));
        if (!persitenceTimeIda) {
            persitenceTimeIda = {};
        }
        persitenceTimeIda[this._stretch.id] = timeIda;
        Storage.set('lastTimeIda', JSON.stringify(persitenceTimeIda));
        this._timeIda = timeIda;
    }
    setTimeIda(timeIda) {
        this._timeIda = timeIda;
        if (!this._lastHoraIda) {
            this._lastHoraIda = {};
        }
        this._lastHoraIda[this.stretch.id] = timeIda;
        this.datebook.setHours(timeIda.hours, timeIda.minutes, 0, 0);
    }
    setNumero(numero) {
        this._numero = numero;
    }
    setTipoPago(tipoPago) {
        if (typeof tipoPago === 'boolean') {
            this._tipoPago = tipoPago ? PaymentMethod.Cash : PaymentMethod.Card;
        }
        else {
            this._tipoPago = tipoPago;
        }
    }
    setAllMoneyToPaymentMethod(method) {
        if (!method) {
            return;
        }
        switch (method) {
            case PaymentMethod.Cash:
                this.setAllMoneyToCash();
                break;
            case PaymentMethod.Card:
                this.setAllMoneyToCard();
                break;
            case PaymentMethod.Credit:
                this.setAllMoneyToCredit();
                break;
            case PaymentMethod.Transfer:
                this.setAllMoneyToTransfer();
                break;
            case PaymentMethod.Other:
                this.setAllMoneyToOther();
                break;
            default:
        }
    }
    setAllMoneyToCash() {
        if (this.total > 0) {
            this.setInputCard(0);
            this.setInputCredit(0);
            this.setInputTransfer(0);
            this.setInputOther(0);
        }
    }
    setAllMoneyToCard() {
        if (this.total > 0) {
            this.setInputCard(this.total - this.totalDue);
            this.setInputCredit(0);
            this.setInputTransfer(0);
            this.setInputOther(0);
        }
    }
    setAllMoneyToCredit() {
        if (this.total > 0) {
            this.setInputCard(0);
            this.setInputCredit(this.total - this.totalDue);
            this.setInputTransfer(0);
            this.setInputOther(0);
        }
    }
    setAllMoneyToTransfer() {
        if (this.total > 0) {
            this.setInputCard(0);
            this.setInputCredit(0);
            this.setInputTransfer(this.total - this.totalDue);
            this.setInputOther(0);
        }
    }
    setAllMoneyToOther() {
        if (this.total > 0) {
            this.setInputCard(0);
            this.setInputCredit(0);
            this.setInputTransfer(0);
            this.setInputOther(this.total - this.totalDue);
        }
    }
    setInputCard(importe) {
        this._totalCard = importe;
    }
    setInputDefer(importe) {
        this._totalDue = importe;
    }
    setInputCredit(importe) {
        this._totalCredit = importe;
    }
    setInputTransfer(importe) {
        this._totalTransfer = importe;
    }
    setInputOther(importe) {
        this._totalOther = importe;
    }
    setAfiliate(value) {
        // console.log('TempSaleTicket - setAfiliate - value: ', value)
        this._afiliate = value;
    }
    // para guardar el número de reserva si va de un afiliado en venta desde un virtual
    setCrossBookingNumber(value) {
        this._crossBookingNumber = value;
    }
    setBoardingPass(value) {
        this._boardingPass = value;
    }
    setDiscountReason(value) {
        this._discountReason = value;
    }
    setTypeDiscount(type) {
        // console.log('type: ', type)
        // corrijo si el valor de discount es superior a 100 y se ha cambiado a porcentaje
        // para evitar hacer tickets con un % superior a 100
        if (type === TypeDiscount.Percentage && this._discount > 100) {
            this._discount = 100;
        }
        this._typeDiscount = type;
    }
    setDataContact(data) {
        this._dataContact = data;
    }
    resetDataContact() {
        this._dataContact = {
            name: '',
            surname: '',
            telephone: '',
            email: '',
            additionalInformation: '',
        };
    }
    // método para cambiar los importes de lines la cambiar el afiliado
    setSale(sale) {
        this._lines.forEach((line) => {
            const result = sale.find((value) => value.stretchPrice.passengerCategory.id ===
                line.stretchPrice.passengerCategory.id);
            if (result) {
                line.setSale(result);
            }
        });
    }
    setAdditional(additional) {
        this._additional = additional;
    }
    get additional() {
        return this._additional;
    }
    get terminal() {
        return 'virtual';
    }
    get payments() {
        const payments = [];
        if (this.totalCash > 0) {
            const payment = new TicketPayment(PaymentMethod.Cash);
            payment.setAmount(this.totalCash);
            payments.push(payment.toJSON());
        }
        if (this._totalCard > 0) {
            const payment = new TicketPayment(PaymentMethod.Card);
            payment.setAmount(this._totalCard);
            // TODO falta añadir el receipt del pago por tarjeta cuando esté implementado
            payments.push(payment.toJSON());
        }
        if (this._totalDue > 0) {
            const payment = new TicketPayment(PaymentMethod.Due);
            payment.setAmount(this._totalDue);
            payments.push(payment.toJSON());
        }
        if (this._totalCredit > 0) {
            const payment = new TicketPayment(PaymentMethod.Credit);
            payment.setAmount(this._totalCredit);
            payment.setAfiliate(this._afiliate);
            payments.push(payment.toJSON());
        }
        if (this._totalTransfer > 0) {
            const payment = new TicketPayment(PaymentMethod.Transfer);
            payment.setAmount(this._totalTransfer);
            payments.push(payment.toJSON());
        }
        if (this._totalOther > 0) {
            const payment = new TicketPayment(PaymentMethod.Other);
            payment.setAmount(this._totalOther);
            payments.push(payment.toJSON());
        }
        return payments;
    }
    toJSON() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        // imagen para el correo
        const urlImage = this._stretch.image
            ? this._stretch.image
            : ((_a = this._stretch.dataweb) === null || _a === void 0 ? void 0 : _a.image1) || null;
        const collaboratorSaleFields = {};
        // añado campos para ticket en colaboración
        if (this._stretch instanceof CollaboratorStretch) {
            collaboratorSaleFields['client_id'] = this._client_id;
            collaboratorSaleFields['collaboratorName'] = this._collaboratorName;
            collaboratorSaleFields['operator_id'] = this._operator_id;
            collaboratorSaleFields['operatorName'] = this._operatorName;
            collaboratorSaleFields['totalNet'] = round(this.totalNet, 2);
        }
        const taxAmount = 0;
        let taxes = {};
        // calculamos taxes
        if (this._extraLines) {
            // taxes de extras
            const extraLines = this._extraLines.map((line) => line.toJSON());
            taxes = getTaxesFromExtraLines(extraLines);
        }
        if (this.tramoHora && this.timeIda) {
            this.datebook.setHours(this.timeIda.hours, this.timeIda.minutes, 0, 0);
        }
        // fecha NTZ
        const datebook = this._datebook;
        const datebookNTZ = new Date(Date.UTC(datebook.getFullYear(), datebook.getMonth(), datebook.getDate(), datebook.getHours(), datebook.getMinutes(), 0, 0));
        // gestionamos emails
        // añado emails de contacto en la venta
        let emails;
        if (!this.dataContact) {
            emails = '';
        }
        else {
            emails = (_b = this._dataContact.email) !== null && _b !== void 0 ? _b : '';
        }
        // añado emails de afiliado
        if (this.afiliate && this.afiliate.email && this.afiliate.email !== '') {
            if (emails !== '') {
                emails = emails.concat(', ').concat(this.afiliate.email);
            }
            else {
                emails = emails.concat(this.afiliate.email);
            }
        }
        // añado emails de stretch
        if (this._stretch.emails) {
            if (emails !== '') {
                emails = emails.concat(', ').concat(this._stretch.emails);
            }
            else {
                emails = emails.concat((_c = this._stretch.emails) !== null && _c !== void 0 ? _c : '');
            }
        }
        return Object.assign(Object.assign({ urlImage }, collaboratorSaleFields), { numero: this._numero, datebook: this._datebook, // '2019-06-17 09:23:54+02',
            datebookNTZ, hours: this._timeIda ? this._timeIda.hours : null, minutes: this._timeIda ? this._timeIda.minutes : null, datecheck: this._datecheck, user_id: this.user.id, username: this.user.username, discount: this._discount, discountReason: this._discountReason, typeDiscount: this._typeDiscount, totalDiscount: this.totalDiscount, netAmount: this.base, taxAmount: this.taxAmount, taxName: this.taxName, total: round(this.total, 2), totalDue: round(this.totalDue, 2), origin: this.origin, destination: this.destination, terminal: 'virtual', daterefund: null, userRefund: null, operationLine_id: this._operationLine.id, operationLineName: this._operationLine.name, businessUnitName: this.businessUnitName, receiptLayout_id: 1, tin: this.tin, stretch_id: this._stretch.id, stretchName: this._stretch.name, datevalited: this.datevalited, codeDiscount: this._codeDiscount ? this._codeDiscount.toString() : null, vuelta: this._saleVuelta, printPrice: this.printPrice, numberScanned: this.datevalited ? 1 : 0, numberPrinted: 1, hoponHopoff: this.hoponHopoff, tramoHora: this.tramoHora, timeExpiration: this.timeExpiration, timeAdvance: this.timeAdvance, timeDelay: this.timeDelay, timeUse: this.timeUse, payments: this.payments, 
            // stretch: this._stretch, // para PacketTicket
            tramoHoraVuelta: false, horasVuelta: this.horasVuelta, aditionalInfo: this._stretch.aditionalInfo, lines: this.lines.map((line) => line.toJSON()), 
            // @ts-ignore
            extraLines: JSON.stringify(this._extraLines.map((line) => line.toJSON())), ticketExtras: this._includedExtraLines.map((line) => line.toJSON()), money: this._stretch.primaryMoney.alphabeticCode, contact: this._dataContact, emails, businessEmails: (_d = this._stretch.operationLine.businessUnit.emails) !== null && _d !== void 0 ? _d : '', externalCode: this._boardingPass ? this._crossBookingNumber : '', boardingPass: this._boardingPass, afiliateName: (_e = this._afiliate) === null || _e === void 0 ? void 0 : _e.name, afiliateCommission: (_f = this._afiliate) === null || _f === void 0 ? void 0 : _f.commission, afiliate_id: (_g = this._afiliate) === null || _g === void 0 ? void 0 : _g.id, typeCommission: (_h = this._afiliate) === null || _h === void 0 ? void 0 : _h.typeCommission, afiliateEmail: (_j = this._afiliate) === null || _j === void 0 ? void 0 : _j.email, additional: this.additional });
    }
}
__decorate([
    observable
], TempSaleTicket.prototype, "_printPrice", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_discount", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_codeDiscount", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_typeDiscount", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_lines", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_datebook", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_valitedNow", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_tipoPago", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_totalCard", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_totalDue", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_totalCredit", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_totalTransfer", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_totalOther", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_afiliate", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_discountReason", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_timeIda", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_lastHoraIda", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_extraLines", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_includedExtraLines", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_saleVuelta", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_originDestination", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_dataContact", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_crossBookingNumber", void 0);
__decorate([
    observable
], TempSaleTicket.prototype, "_boardingPass", void 0);
__decorate([
    computed
], TempSaleTicket.prototype, "totalPax", null);
__decorate([
    computed
], TempSaleTicket.prototype, "quantityToAdd", null);
__decorate([
    computed
], TempSaleTicket.prototype, "money", null);
__decorate([
    computed
], TempSaleTicket.prototype, "netAmount", null);
__decorate([
    computed
], TempSaleTicket.prototype, "netAmountNet", null);
__decorate([
    computed
], TempSaleTicket.prototype, "netAmountWithoutExtras", null);
__decorate([
    computed
], TempSaleTicket.prototype, "netAmountNetWithoutExtras", null);
__decorate([
    computed
], TempSaleTicket.prototype, "base", null);
__decorate([
    computed
], TempSaleTicket.prototype, "baseNet", null);
__decorate([
    computed
], TempSaleTicket.prototype, "total", null);
__decorate([
    computed
], TempSaleTicket.prototype, "totalNet", null);
__decorate([
    computed
], TempSaleTicket.prototype, "totalPaid", null);
__decorate([
    computed
], TempSaleTicket.prototype, "totalWithoutDiscount", null);
__decorate([
    computed
], TempSaleTicket.prototype, "totalNetWithoutDiscount", null);
__decorate([
    computed
], TempSaleTicket.prototype, "datebook", null);
__decorate([
    computed
], TempSaleTicket.prototype, "datecheck", null);
__decorate([
    computed
], TempSaleTicket.prototype, "dateValited", null);
__decorate([
    computed
], TempSaleTicket.prototype, "valitedNow", null);
__decorate([
    computed
], TempSaleTicket.prototype, "checkins", null);
__decorate([
    computed
], TempSaleTicket.prototype, "discount", null);
__decorate([
    computed
], TempSaleTicket.prototype, "tramoHora", null);
__decorate([
    computed
], TempSaleTicket.prototype, "tipoPago", null);
__decorate([
    computed
], TempSaleTicket.prototype, "totalDiscount", null);
__decorate([
    action
], TempSaleTicket.prototype, "reset", null);
__decorate([
    action
], TempSaleTicket.prototype, "pushLine", null);
__decorate([
    action
], TempSaleTicket.prototype, "pullLine", null);
__decorate([
    action
], TempSaleTicket.prototype, "setSaleVuelta", null);
__decorate([
    action
], TempSaleTicket.prototype, "toggleOriginDestination", null);
__decorate([
    action
], TempSaleTicket.prototype, "setDatecheck", null);
__decorate([
    action
], TempSaleTicket.prototype, "setDatebook", null);
__decorate([
    action
], TempSaleTicket.prototype, "setDatevalited", null);
__decorate([
    action
], TempSaleTicket.prototype, "setValitedNow", null);
__decorate([
    action
], TempSaleTicket.prototype, "setPrintPrice", null);
__decorate([
    action
], TempSaleTicket.prototype, "setMinus", void 0);
__decorate([
    action
], TempSaleTicket.prototype, "setPlus", void 0);
__decorate([
    action
], TempSaleTicket.prototype, "setExtraMinus", void 0);
__decorate([
    action
], TempSaleTicket.prototype, "setExtraPlus", void 0);
__decorate([
    action
], TempSaleTicket.prototype, "setDiscount", null);
__decorate([
    action
], TempSaleTicket.prototype, "setCodeDiscount", null);
__decorate([
    action
], TempSaleTicket.prototype, "handleChangeDate", void 0);
__decorate([
    action
], TempSaleTicket.prototype, "setMinimun", void 0);
__decorate([
    action
], TempSaleTicket.prototype, "setStretch", null);
__decorate([
    action
], TempSaleTicket.prototype, "setOperationLine", null);
__decorate([
    action
], TempSaleTicket.prototype, "setPersistenceTimeIda", null);
__decorate([
    action
], TempSaleTicket.prototype, "setTimeIda", null);
__decorate([
    action
], TempSaleTicket.prototype, "setTipoPago", null);
__decorate([
    action
], TempSaleTicket.prototype, "setAllMoneyToPaymentMethod", null);
__decorate([
    action
], TempSaleTicket.prototype, "setInputCard", null);
__decorate([
    action
], TempSaleTicket.prototype, "setInputDefer", null);
__decorate([
    action
], TempSaleTicket.prototype, "setInputCredit", null);
__decorate([
    action
], TempSaleTicket.prototype, "setInputTransfer", null);
__decorate([
    action
], TempSaleTicket.prototype, "setInputOther", null);
__decorate([
    action
], TempSaleTicket.prototype, "setAfiliate", null);
__decorate([
    action
], TempSaleTicket.prototype, "setCrossBookingNumber", null);
__decorate([
    action
], TempSaleTicket.prototype, "setBoardingPass", null);
__decorate([
    action
], TempSaleTicket.prototype, "setDiscountReason", null);
__decorate([
    action
], TempSaleTicket.prototype, "setTypeDiscount", null);
__decorate([
    action
], TempSaleTicket.prototype, "setDataContact", null);
__decorate([
    action
], TempSaleTicket.prototype, "setKeyValueDataContact", void 0);
__decorate([
    action
], TempSaleTicket.prototype, "resetDataContact", null);
__decorate([
    action
], TempSaleTicket.prototype, "setSale", null);
export const getTaxesFromExtraLines = (extraLines) => {
    if (!extraLines) {
        return {};
    }
    const taxes = {};
    for (let i = 0; i < extraLines.length; i++) {
        if (taxes[extraLines[i].taxName]) {
            // ya está
            taxes[extraLines[i].taxName] += extraLines[i].taxAmount;
        }
        else {
            // no está
            taxes[extraLines[i].taxName] = extraLines[i].taxAmount;
        }
    }
    return taxes;
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/TempSale/TempSaleTicket.ts
// module id = 154
// module chunks = 0